// extracted by mini-css-extract-plugin
export default {"spinner":"SpinnerBorder_spinner__vWqHZ","spinner-border":"SpinnerBorder_spinner-border__7lB4i"};